import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleSelect = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="categories" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 mb-5">
          <span className="text-xs font-medium text-accent-700 tracking-wide">Quick Navigation</span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Browse Product Categories
        </h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-lg mx-auto">
          Select a category below to explore the latest Sugargoo spreadsheet finds and curated product collections.
        </p>

        <div className="relative">
          <select
            onChange={(e) => {
              if (e.target.value) handleSelect(e.target.value);
            }}
            defaultValue=""
            className="w-full appearance-none bg-background-100 border border-background-200 rounded-xl px-5 py-4 pr-12 text-sm font-medium text-foreground-800 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all cursor-pointer"
          >
            <option value="" disabled>-- Choose a Category --</option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.displayName}
              </option>
            ))}
          </select>
          <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}